export interface SalesDespatchItemAddRemove {
  salesDespatchNoteId: string;
  salesDespatchItemId: string;
}
